import { Button } from "primereact/button";
import React, { useState } from "react";
import { homePagePath, passwordRegEx } from "../../../constant";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { isValidPhoneNumber } from 'libphonenumber-js';
import LOGO from "../../assets/thurent-logo.svg";
import "./Login.css";
import { signup } from "../../../Apiservices/Auth/servers/signUpServer";
import { setToken } from "../../../util/Cookies";
import { handlePendingEvent, setCredentials } from "../../../store/authSlice";
import { Dialog } from "primereact/dialog";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { detectAndSaveUserCountry } from "../../../util/geoUtils";

function ThurentSignUp() {
  const phoneRegExp = /^[6-9]\d{9}$/;
  const dispatch = useDispatch();
  const authState = useSelector((state) => state);
  const { loading, user, error } = authState || {};
  const navigate = useNavigate();
  const [phoneValue, setPhoneValue] = useState('');
  const [agreedToPolicy, setAgreedToPolicy] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('in');
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showErrorDialogVisible, setShowErrorDialogVisible] = useState(false);
  const [errorDialogCont, setErrorDialogCont] = useState({});

  React.useEffect(() => {
    // Force location detection on page mount (no permission popup)
    const initLocation = async () => {
      const countryData = await detectAndSaveUserCountry();
      if (countryData && countryData.lowerIsoCode) {
        setSelectedCountry(countryData.lowerIsoCode);
        formik.setFieldValue('countryCode', countryData.countryCode);
      }
    };
    initLocation();
  }, []);

  const showErrorDialog = (msg) => {
    setShowErrorDialogVisible(true);
    switch (msg) {
      case "User already exists.":
        setErrorDialogCont({
          content: "A user with this email or mobile number already exists.",
          btn: true,
        });
        break;
      default:
        setErrorDialogCont({ content: msg, btn: false });
    }
  };

  // Formik form handling
  const formik = useFormik({
    initialValues: {
      firstName: "",
      email: "",
      mobileNumber: "",
      password: "",
      countryCode: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Name is required"),
      email: Yup.string()
        .trim()
        .nullable()
        .test("is-valid-or-empty", "Invalid email format", function (value) {
          if (!value) return true;
          return Yup.string().email().isValidSync(value);
        }),
      mobileNumber: Yup.string()
        .required("Mobile number is required")
        .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),

      password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .matches(
          passwordRegEx,
          "Password must include AT LEAST ONE uppercase, lowercase, number and special character"
        )
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      if (!agreedToPolicy) {
        showErrorDialog("Please agree to the Privacy Policy before signing up.");
        return;
      }
      try {
        const data = await signup(values);
        console.log("response", data)
        if (data.token) {
          setToken(data.token);
          dispatch(setCredentials(data));
          dispatch(handlePendingEvent());
          navigate("/dashboard");
        }
      } catch (error) {
        showErrorDialog(error.message || "");
        console.log("Error: In Signup ");
        console.log("hello", error);
      }
    },
  });
  return (
    <div className="th-auth">
      <Dialog
        className="th-auth__dialog"
        visible={showErrorDialogVisible}
        modal
        header={`Error`}
        footer={
          errorDialogCont.btn ? (
            <div>
              <Button
                size="small"
                label="Login"
                onClick={() => navigate("/login")}
              />
              <Button
                size="small"
                label="Forgot Password"
                onClick={() => navigate("/forgot-password")}
              />
            </div>
          ) : (
            <Button
              size="small"
              label="OK"
              onClick={() => setShowErrorDialogVisible(false)}
            />
          )
        }
        onHide={() => {
          if (!showErrorDialogVisible) return;
          setShowErrorDialogVisible(false);
        }}
      >
        <h4 style={{ fontWeight: "500" }}>{errorDialogCont.content}</h4>
      </Dialog>
      <div className="th-auth__container">
        <img
          src={LOGO}
          alt="thurent"
          className="th-auth__logo"
          onClick={() => {
            navigate(homePagePath);
          }}
        />
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <input
              type="text"
              name="firstName"
              placeholder="Full Name"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              className="th-login__input"
            />
            {formik.touched.firstName && formik.errors.firstName && (
              <span className="error">{formik.errors.firstName}</span>
            )}
          </div>

          <div className="mb-3">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className="th-login__input"
            />
            {(formik.touched.email || formik.submitCount > 0) && formik.errors.email && (
              <span className="error">{formik.errors.email}</span>
            )}

          </div>





          <div className="mb-3">
            <PhoneInput
              country={selectedCountry}
              onlyCountries={['in', 'us']}
              style={{ width: "100%" }}
              disableCountryCode={true}
              disableDropdown={true}
              value={phoneValue}
              onChange={(value, data) => {
                // Store the full value (with dial code) in local state so PhoneInput
                // is correctly controlled and doesn't re-parse on re-render.
                setPhoneValue(value);

                const dialCode = data.dialCode;       // e.g., "91"
                const countryCode = `+${dialCode}`;   // "+91"

                // react-phone-input-2 with disableCountryCode={true} still prepends
                // the dial code internally to `value`. Strip it exactly once.
                // Do NOT use startsWith here — use slice only when the library has
                // prepended the code, otherwise keep as-is.
                const nationalNumber = value.startsWith(dialCode)
                  ? value.slice(dialCode.length)
                  : value;

                // Cap at 10 digits for the national number stored in formik
                const cleanedValue = nationalNumber.slice(0, 10);

                formik.setFieldValue('countryCode', countryCode);
                formik.setFieldValue('mobileNumber', cleanedValue);
                setSelectedCountry(data.countryCode);
              }}
              placeholder="Mobile Number"
              inputProps={{
                name: 'mobileNumber',
                required: true,
                onBlur: formik.handleBlur,
              }}
              containerClass="phone-container"
              inputClass="phone-input"
              buttonClass="phone-flag-button"
            />




            {/* <input
            type="text"
            name="mobileNumber"
            maxLength="10"
            placeholder="Mobile Number"
            value={formik.values.mobileNumber}
            onChange={formik.handleChange}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"
              ];
            
              if (
                !/[0-9]/.test(e.key) &&
                !allowedKeys.includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            className="th-login__input"
          /> */}

            {formik.touched.mobileNumber && formik.errors.mobileNumber && (
              <span className="error">{formik.errors.mobileNumber}</span>
            )}
          </div>

          <div className="mb-3">
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                className="th-login__input"
              />
              <IconButton
                aria-label={
                  showPassword ? "hide the password" : "display the password"
                }
                onClick={handleClickShowPassword}
                edge="end"
                sx={{ position: "absolute", right: "12px", top: "-2px" }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>

            {formik.touched.password && formik.errors.password && (
              <span className="error">{formik.errors.password}</span>
            )}
          </div>
          <div className="mb-3 flex align-items-center">
            <input
              type="checkbox"
              id="policy-agreement"
              checked={agreedToPolicy}
              onChange={(e) => setAgreedToPolicy(e.target.checked)}
              style={{ marginRight: "8px" }}
            />
            <label htmlFor="policy-agreement" style={{ fontSize: "14px" }}>
              I agree to the{" "}
              <Link to="/privacy-policy" style={{ color: "#26b8e3" }}>
                Privacy Policy
              </Link>
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="th-login__button font-inter"
          >
            <span className="Login-bitton"> {loading ? "SIGNING UP..." : "SIGNUP"}</span>
          </button>
          {error && <span className="error">Error: {error}</span>}
        </form>
        <button
          className="th-signup__button font-inter font-normal"
          onClick={() => navigate("/login")}
        >
          <span style={{ color: "red" }}>Existing User?</span> LOGIN
        </button>

        <div
          style={{
            fontSize: "12px",
            fontWeight: "500",
            color: "#888",
            marginTop: "15px",
            textAlign: "left",
          }}
        >
          By creating an account or logging in, you agree to Thurent’s{" "}
          <Link
            to="/privacy-policy"
            style={{ color: "#26b8e3", margin: "0 4px" }}
          >
            Privacy Policy.
          </Link>
        </div>

        <div className="flex w-full justify-content-center align-items-center mt-3">
          <Button
            label="Back to Home"
            icon="pi pi-home"
            className="th-backtohome__button"
            iconPos="left"
            severity="contrast"
            onClick={() => navigate(homePagePath)}
            size="small"
          />
        </div>
      </div>
    </div>
  );
}

export default ThurentSignUp;
